// import { checkResponse, post, get } from "@/utils/http"
import { APP_CONFIG } from '@/utils/constants'
import HttpService from "@/utils/httpData"
import JWT from "@/utils/jwt"

export function info() {
    return HttpService.get(`${APP_CONFIG.apiUrl}profile`)
        .then((res) => {
            if (!res) { return false; }
            return res.data;
        })
}

// export function register(data) {
//     return HttpService.post(`register`, data)
//         .then((res) => {
//             return res && res.data ? res.data : fasle;
//             // if(!res) {return false; }
//             //         console.log(res)
//             //     JWT.saveToken(res.data.data.accessToken, 30);
//             //     return res.data.data.accessToken;
//             // })
//         })
// }
export function register(data) {
    return HttpService.post(`register`, data)
        .then((res) => {
            return res && res.data ? res.data : fasle;
            // if(!res) {return false; }
            //         console.log(res)
            //     JWT.saveToken(res.data.data.accessToken, 30);
            //     return res.data.data.accessToken;
            // })
        })
}
export function register2(data) {
    return HttpService.post(`auth/register`, data)
        .then(checkResponse)
}

export function login(username, password) {
    return HttpService.post(`login`, { email: username, password })
        .then((response) => {
            if (!response) { return false; }
            JWT.saveToken(response.data.data.accessToken, 30);
            if (response.data.data.userProfile) {
                if (response.data.data.userProfile.otp) {
                    response.data.data.userProfile.otp = btoa(response.data.data.userProfile.otp)
                }
                JWT.saveAuth(response.data.data.userProfile);
            }
            return response.data.data;
        }).catch((err) => { return false });
}

export function loginGoogle(token) {
    return HttpService.post(`auth/google`, { access_token: token })
        .then(checkResponse)
}

export function loginFacebook(data) {
    return HttpService.post(`${APP_CONFIG.apiUrl}/auth/facebook`, data)
        .then(checkResponse)
}

export function refreshToken() {
    return HttpService.post(`${APP_CONFIG.apiUrl}/auth/token-refresh`)
        .then(checkResponse)
}

export const checkExitEmail = (payload) => {
    return HttpService.post(`validateemail`, payload).then(res => {
        if (res.errors || !res.data) {
            return false;
        }
        return res.data;
    }).catch(e => { return false });
}
export function logout() {
    JWT.destroyToken();
    // return post(`${APP_CONFIG.apiUrl}/auth/logout`)
    //     .then(checkResponse)
}
export const checkEmailForgot = (payload) => {
    let apiEndpoint = 'Forgot-Password';
    return HttpService.post(apiEndpoint, payload).then(res => {
        if (res.errors || !res.data) {
            return false;
        }
        return res.data;
    }).catch(e => { return false });
}
export const apiResetPassword = (payload) => {
    let apiEndpoint = 'ResetPassword';
    return HttpService.post(apiEndpoint, payload).then(res => {
        if (res.errors || !res.data) {
            return false;
        }
        return res.data;
    }).catch(e => { return false });
}